module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b587f0f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar.vue
// module id = 651
// module chunks = 1